/* eslint-disable */
import React from 'react';

import { Element } from './styled';

const Container = props => (
    <Element {...props} />
);

export default Container;
